module.exports = __webpack_public_path__ + "assets/gif-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/gif-icon.svg
// module id = 811
// module chunks = 0